import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router';
import { FullscreenLoadingSpinner } from '@/shared/components/FullscreenLoadingSpinner.tsx';
import type { OidcAppState } from '@/tools/auth/oidcConfig.ts';

/**
 * Handles the OAuth redirect at /auth/callback. react-oidc-context performs the code
 * exchange automatically as soon as the provider mounts on this URL; once authenticated
 * we navigate back to the location the user came from.
 */
export function AuthCallback() {
    const auth = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (auth.isAuthenticated) {
            const returnTo = (auth.user?.state as OidcAppState | undefined)?.returnTo ?? '/';
            void navigate(returnTo, { replace: true });
        }
    }, [auth.isAuthenticated, auth.user, navigate]);

    if (auth.error) {
        return <div role="alert">Authentication failed: {auth.error.message}</div>;
    }

    return <FullscreenLoadingSpinner />;
}
